// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 781 ? "form-schema-jsuites" : chunkId) + "." + {"216":"012171f7","667":"012171f7","781":"06778531"}[chunkId] + ".chunk.css";
};